import { render, staticRenderFns } from "./VerticalDivider.vue?vue&type=template&id=669d2efa&scoped=true"
import script from "./VerticalDivider.vue?vue&type=script&lang=ts"
export * from "./VerticalDivider.vue?vue&type=script&lang=ts"
import style0 from "./VerticalDivider.vue?vue&type=style&index=0&id=669d2efa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d2efa",
  null
  
)

export default component.exports